export default "__VITE_ASSET__d01201c3__"